var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLock = function SvgLock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M6 22a2 2 0 0 1-1.4-.6A2 2 0 0 1 4 20V10c0-.6.2-1 .6-1.4A2 2 0 0 1 6 8h1V6c0-1.4.5-2.6 1.5-3.5 1-1 2.1-1.5 3.5-1.5s2.6.5 3.5 1.5c1 1 1.5 2.1 1.5 3.5v2h1c.6 0 1 .2 1.4.6s.6.8.6 1.4v10c0 .6-.2 1-.6 1.4a2 2 0 0 1-1.4.6zm6-5c.6 0 1-.2 1.4-.6s.6-.8.6-1.4-.2-1-.6-1.4A2 2 0 0 0 12 13a2 2 0 0 0-1.4.6A2 2 0 0 0 10 15c0 .6.2 1 .6 1.4s.8.6 1.4.6M9 8h6V6q0-1.2-.9-2.1T12 3c-1.2 0-1.5.3-2.1.9Q9 4.8 9 6z"
  })));
};
export default SvgLock;